module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Piano RO.3fafb9c0.png";